const state = {
    
    cards: [],
    table: [],
    typePaymentMethon: [],
    loadingCode: null
    
};

export default state;